import { useEffect, useState } from 'react'

import { Tab } from 'components'

import AddNewTalkToUs from './components/AddNewTalkToUs'
import SearchTalkToUs from './components/SearchTalkToUs'
import ViewTalkToUs from './components/ViewTalkToUs'

const TalkToUsSupplier = () => {
  const [selectedTab, setSelectedTab] = useState<number>(0)
  const tabs = ['Pesquisar', 'Adicionar Novo']
  const [selectedTalkToUsId, setSelectedTalkToUs] = useState<number>(null)

  const handleChange = (_, newValue) => setSelectedTab(newValue)

  useEffect(() => {
    if (selectedTab === 0) {
      setSelectedTalkToUs(0)
    }
  }, [selectedTab])

  const handleSetSelectedTalkToUs = (idFaleConosco: number) => {
    setSelectedTalkToUs(() => idFaleConosco)
    setSelectedTab(() => 1)
  }

  return (
    <>
      <Tab tabs={tabs} value={selectedTab} handleChange={handleChange} />
      {selectedTab === 0 ? (
        <>
          <SearchTalkToUs setSelectedTalkToUs={handleSetSelectedTalkToUs} />
        </>
      ) : (
        <>
          {selectedTalkToUsId ? (
            <ViewTalkToUs faleConoscoId={selectedTalkToUsId} />
          ) : (
            <AddNewTalkToUs setSelectedTab={setSelectedTab} />
          )}
        </>
      )}
    </>
  )
}

export default TalkToUsSupplier
